import { ContentItem } from "../ContentItem/ContentItem";
import { ContentParent } from "../ContentParent";
import { Translate } from "components/common/Translate/Translate";
import { getCDNIcon } from "../ImageResizerContent/ImageResizerContent";
import { translateFunc } from "client/utils/translateFunc";
import { EasyToUseIcon } from "components/common/Icons/EasyToUseIcon";
import { PerfectQualityIcon } from "components/common/Icons/PerfectQualityIcon";
import { ImageFormatsIcon } from "components/common/Icons/ImageFormatsIcon";
import { PrivacyGuaranteedIcon } from "components/common/Icons/PrivacyGuaranteedIcon";
import { LightningFastIcon } from "components/common/Icons/LightningFastIcon";
import { HeartIcon } from "components/common/Icons/HeartIcon";

export const CropperWebpContent = () => {
    return (
        <ContentParent>
            <ContentItem
                title={<Translate keyName="content-instant-title" />}
                description={<Translate keyName="content-instant-sub-title" />}
                icon={<EasyToUseIcon />}
            />
            <ContentItem
                title={<Translate keyName="content-quality-title" />}
                description={<Translate keyName="content-quality-sub-title" />}
                icon={<PerfectQualityIcon />}
            />
            <ContentItem
                title={<Translate keyName="content-controls-title" />}
                description={<Translate keyName="content-controls-sub-title" />}
                icon={<ImageFormatsIcon />}
            />
            <ContentItem
                title={<Translate keyName="content-install-title" />}
                description={<Translate keyName="content-install-sub-title" />}
                icon={<PrivacyGuaranteedIcon />}
            />
            <ContentItem
                title={<Translate keyName="content-device-title" />}
                description={<Translate keyName="content-device-sub-title" />}
                icon={<LightningFastIcon />}
            />
            <ContentItem
                title={<Translate keyName="content-privacy-title" />}
                description={<Translate keyName="content-privacy-sub-title" />}
                icon={<HeartIcon />}
            />
        </ContentParent>
    );
};
